<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMyOrderPaybackPackageFeeList"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">退纸箱费列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['G'])||($checkAccessArray(['B'])&&!isSeedFarmMainAccount)"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onOrderPaybackPackageFeeCreate">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        <Button type="info" size='small' class="btns" shape="circle" icon="ios-send"
                            @click="onExport()">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMyOrderPaybackPackageFeeList" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="orderPaybackPackageFeeModal.show"
            title="新增退纸箱费单"
            class-name="vertical-center-modal"
            width="600">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="24">
                    <FormItem label="发货单号">
                        <Input v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeOrderCode"
                            search
                            enter-button
                            placeholder="输入发货单号，点击搜索.."
                            @on-search="onSearchOrder()">
                        </Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="客户名称">
                        <Input readonly
                            v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeCustomerPersonName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="客户账号">
                        <Input readonly
                            v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeCustomerName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="纸箱单价">
                        <InputNumber v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeePrice"
                            :min="0"
                            :active-change="false"
                            @on-change="calculateVale()"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="纸箱数量">
                        <InputNumber v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeQuantity"
                            :min="0"
                            :active-change="false"
                            @on-change="calculateVale()"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="纸箱金额">
                        <Input readonly
                            v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeValue"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="苗场编号">
                        <!-- <Input readonly
                            v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmCode"></Input> -->
                     <Select v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmCode"  disabled @on-change="changeSeedFarmCode"
                     clearable  filterable>
				        <Option v-for="item in seedFarmList"
				            :key="item.seedFarmCode"
				            :value="item.seedFarmCode">{{ item.seedFarmCode }}</Option>
				    </Select>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="苗场名称">
                        <Input readonly
                            v-model="orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmName"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary"
                    @click="onOrderPaybackPackageFeeSave">确认</Button>
                <Button type="error"
                    @click="orderPaybackPackageFeeModal.show=false">取消</Button>
            </div>
        </Modal>
		
		<Modal v-model="cancelModel.show"
		    title="撤销退纸箱费"
		    class-name="vertical-center-modal"
		    width="800">
		    <Spin v-if="innerSpin"
		        size="large"
		        fix></Spin>
		    <Form label-position="top"
			ref="cancelModel"
			:model="cancelModel">
		        <Row :gutter="16">
		            <Col span="24">
		            <FormItem label="填写撤销原因:" prop="cancelReason">
						<Input v-model="cancelModel.cancelReason" type="textarea" placeholder="请填写撤销当前退纸箱费的原因"></Input>
		               
		            </FormItem>
		            </Col>
		        </Row>
		    </Form>
		    <div slot="footer">
		        <Button type="primary"
		            @click="onCancelSave">确认撤销</Button>
		        <Button type="error"
		            @click="onClose">取消</Button>
		    </div>
		</Modal>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import { numberToFixed } from '@/components/number-input/display-format';
import { getSaleOrderDetailByCode, getSaleOrderDetailByCodeAnduserCustomerManager } from "@/api/modules/sale-management/sale-approve";
import { addOrderPaybackPackageFee, getOrderPaybackPackageFeeList, approvalOrderPaybackPackageFee, cancelOrderPaybackPackageFee } from "@/api/modules/finance-management/package-fee";
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import {
    getBinFenSeedFarmUserDetail
} from '@/api/modules/account-management/binFenSeedFarm-user-management';
import { getSeedFarmList	} from '@/api/modules/system-management/seedFarm-management';
import loginState from '@/libs/loginState';



export default {
    name: "OrderPaybackPackageFeeList",
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            cancelModel:{
                show:false,
                orderPaybackPackageFeeUuid:'',
                cancelReason:''
            },
            innerSpin: false,
            mainTable: {
                columns: [
                    { title: "行号", key: "index", width: 50, align: "center" },
                    { title: "退费单号", key: "orderPaybackPackageFeeCode", width: 160, align: "center", excel: true },
                    { title: "发货单号", key: "orderPaybackPackageFeeOrderCode", width: 160, align: "center", excel: true },
                    { title: "会员编号", key: "orderPaybackPackageFeeCustomerName", align: "center", excel: true },
                    { title: "会员名称", key: "orderPaybackPackageFeeCustomerPersonName", align: "center", excel: true },
                    { title: "苗场编号", key: "orderPaybackPackageFeeSeedFarmCode", align: "center", excel: true },
                    { title: "苗场名称", key: "orderPaybackPackageFeeSeedFarmName", align: "center", excel: true },
                    { title: "纸箱单价", key: "orderPaybackPackageFeePrice", align: "center", excel: true },
                    { title: "纸箱数量", key: "orderPaybackPackageFeeQuantity", align: "center", excel: true },
                    { title: "纸箱金额", key: "orderPaybackPackageFeeValue", align: "center", excel: true },
                    { title: "经办人", key: "orderPaybackPackageFeeOperator", align: "center", excel: true },
                    {
					    title: '状态',
					    key: 'status',
					    align: 'center'
                    },
                    {
                        title: '审核状态',
                        key: 'approvalStatus',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.approvalStatus))
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "orderPaybackPackageFeeCreateAt",
                        align: "center",
                        width: 120,
                        excel: true,
                        render: (h, params) =>
                            dateTimeRender(h, params.row.orderPaybackPackageFeeCreateAt)
                    },
                    {
                        title: "审批时间",
                        key: "orderPaybackPackageFeeapprovalTime",
                        align: "center",
                        width: 120,
                        excel: true,
                        render: (h, params) =>
                            dateTimeRender(h, params.row.orderPaybackPackageFeeapprovalTime)
                    },
                    {
                        title: '操作',
                        key: 'approvalAction',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.approvalStatus == 2) {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                        	display: (this.$checkAccessArray(['B'])&&this.isSeedFarmMainAccount) ? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.onPass(params.row);
                                            }
                                        }
                                    }, '通过'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            display: (this.$checkAccessArray(['B'])&&this.isSeedFarmMainAccount) ? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.onFail(params.row);
                                            }
                                        }
                                    }, '不通过'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            display: this.isCancleOrder(params.row)? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.cancleOrder(params.row.orderPaybackPackageFeeUuid);
                                            }
                                        }
                                    }, '撤销')
                                ]);
                            }
                            else if(params.row.approvalStatus == 1){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            display: this.isCancleOrder(params.row)? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.cancleOrder(params.row.orderPaybackPackageFeeUuid);
                                            }
                                        }
                                    }, '撤销')
                                ]);
                            }
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: "退费单号", type: "Input", value: "", name: "orderPaybackPackageFeeCode", sql: "like" },
                    { label: "发货单号", type: "Input", value: "", name: "orderPaybackPackageFeeOrderCode", sql: "like" },
                    { label: "会员", type: "Input", value: "", name: "concat(orderPaybackPackageFeeCustomerName,orderPaybackPackageFeeCustomerPersonName)", sql: "like" },
                    { label: "苗场", type: "Input", value: "", name: "concat(orderPaybackPackageFeeSeedFarmCode,orderPaybackPackageFeeSeedFarmName)", sql: "like" },
                    { label: "经办", type: "Input", value: "", name: "orderPaybackPackageFeeOperator", sql: "like" },
                    { label: '创建时间', type: 'Daterange', value: '', name: 'orderPaybackPackageFeeCreateAt', sql: 'dateBetween' },
                    { label: '审核状态', type: 'Select', name: 'approvalStatus', sql: 'in', options: [{ value: 1, key: '通过' }, { value: 0, key: '未通过' }, { value: 2, key: '审核中' }] }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            orderList: [],
            orderPaybackPackageFeeModal: {
                show: false,
                orderPaybackPackageFeeOrderUuid: '',
                orderPaybackPackageFeeOrderCode: '',
                orderPaybackPackageFeeCustomerName: '',
                orderPaybackPackageFeeCustomerPersonName: '',
                orderPaybackPackageFeeSeedFarmCode: '',
                orderPaybackPackageFeeSeedFarmName: '',
                orderPaybackPackageFeeSeedFarmUuid: '',
                orderPaybackPackageFeePrice: 0,
                orderPaybackPackageFeeQuantity: 0,
                orderPaybackPackageFeeValue: 0
            },
            isSeedFarmMainAccount:false,
            seedFarmList:[]
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMyOrderPaybackPackageFeeList();
            this.getSeedFarmList();
            if(this.$checkAccessArray(['B'])){
                let Useruuid = loginState.getLoginUserID();
                getBinFenSeedFarmUserDetail(Useruuid).then(res=>{
                    if(res.code==0){
                        this.isSeedFarmMainAccount =res.data.userBinFenSeedFarm.isHasRight==1;
                    }
                });
            } 
        },
        isCancleOrder(row){
            if(!this.$checkAccessArray(['B'])){
                return false;
            }
            if(!this.isSeedFarmMainAccount){
                return false;
            }
            if(row.approvalStatus!=1){                         
                return false;
            }
            if(!row.orderPaybackPackageFeeapprovalTime){
                //审批时间为空的不能撤销
                return false;
            }
            if(row.status=='撤销'){
                return false;
            }
            //审批时间
            let approvalDate=new Date(row.orderPaybackPackageFeeapprovalTime);
            let now=new Date();
            let difference = now.getTime() - approvalDate.getTime(); // 计算两个时间戳的差值
            if(difference>24*60*60*1000){
                //审批时间超过24小时的不能撤销
                return false;
            }
            return true;
        },
        changeSeedFarmCode(seedFarmCode){
            if(!seedFarmCode){
                this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmName="";
                this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmUuid="";  
                return;  
            }
            let seedFarmModel=this.seedFarmList.find(item=>item.seedFarmCode==seedFarmCode);       
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmName=seedFarmModel.seedFarmName;
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmUuid=seedFarmModel.seedFarmUuid;  
        },
        getSeedFarmList(){
            let tempSearch = {
                filters: {
                    enable: true,
                    conditions: []
                },
                order: {
                    enable: false,
                    conditions: []
                },
                limit: {
                    enable: false,
                    conditions: {
                        pageLength: 10,
                        pageStart: 1,
                        total: 0
                    }
                },
                excelExport: {
                    enable: false,
                    columns: []
                }
            };   
            getSeedFarmList(tempSearch).then(res => {
                if (res.code === 0) {
					
                    this.seedFarmList = res.data.records;
                }
            });
        },
        cancleOrder(orderPaybackPackageFeeUuid){
            this.cancelModel.orderPaybackPackageFeeUuid=orderPaybackPackageFeeUuid;
            this.cancelModel.show=true;
        },
        onCancelSave(){
            if(!this.cancelModel.orderPaybackPackageFeeUuid){
                this.$Message.error("退纸箱费ID不能为空！");
                return;
            }
            if(!this.cancelModel.cancelReason){
                this.$Message.error("撤销原因不能为空！");
                return;
            }
            this.innerSpin = true;
            cancelOrderPaybackPackageFee(this.cancelModel).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '撤销成功',
                        onOk: () => {
                            this.cancelModel.orderPaybackPackageFeeUuid="";
                            this.cancelModel.cancelReason="";
                            this.cancelModel.show=false;
                            this.init();
                        }
                    });
                }
                else{
                    this.$Message.error(res.message);
                }
            });
        },
        onClose(){
            this.cancelModel.orderPaybackPackageFeeUuid="";
            this.cancelModel.cancelReason="";
            this.cancelModel.show=false;
        },
        calculateVale() {
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeValue = numberToFixed(this.orderPaybackPackageFeeModal.orderPaybackPackageFeePrice * this.orderPaybackPackageFeeModal.orderPaybackPackageFeeQuantity, 2);
        },
        onOrderPaybackPackageFeeCreate() {
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeOrderUuid = '';
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeOrderCode = '';
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeCustomerName = '';
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeCustomerPersonName = '';
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmCode = '';
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmName = '';
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeePrice = 0;
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeQuantity = 0;
            this.orderPaybackPackageFeeModal.orderPaybackPackageFeeValue = 0;
            this.orderPaybackPackageFeeModal.show = true;
            this.orderPaybackPackageFeeModal.approvalStatus = 0;
        },
        onOrderPaybackPackageFeeSave() {
            this.innerSpin = true;
            addOrderPaybackPackageFee(this.orderPaybackPackageFeeModal).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '已成功提交苗场审核',
                        onOk: () => {
                            this.orderPaybackPackageFeeModal.show = false;
                            this.init();
                        }
                    });
                }
            });

        },
        onSearchOrder() {
            if (this.orderPaybackPackageFeeModal.orderPaybackPackageFeeOrderCode) {
                this.innerSpin = true;
                getSaleOrderDetailByCodeAnduserCustomerManager({ orderCode: this.orderPaybackPackageFeeModal.orderPaybackPackageFeeOrderCode }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.orderPaybackPackageFeeModal.orderPaybackPackageFeeOrderUuid = res.data.orderDetail.preSaleDeliveryRecord.preSaleDeliveryRecordUuid;
                        this.orderPaybackPackageFeeModal.orderPaybackPackageFeeCustomerPersonName = res.data.orderDetail.preSaleDeliveryRecord.userPersonName;
                        this.orderPaybackPackageFeeModal.orderPaybackPackageFeeCustomerName = res.data.orderDetail.preSaleDeliveryRecord.preSaleRecordOwnerName;
                        this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmCode = res.data.orderDetail.preSaleDeliveryRecord.seedFarmCode;
                        this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmName = res.data.orderDetail.preSaleDeliveryRecord.seedFarmName;
                        this.orderPaybackPackageFeeModal.orderPaybackPackageFeeSeedFarmUuid = res.data.orderDetail.preSaleDeliveryRecord.preSaleDeliveryRecordSeedFarmUuid;
                        
                    }
                });
            }
        },
        getMyOrderPaybackPackageFeeList(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.loading = true;
            getOrderPaybackPackageFeeList(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    let totalQuantity = 0;
                    let totalValue = 0;
                    let index = 1;
                    this.mainTable.data.forEach(e => {
                        e.index = index++;
                        totalQuantity += e.orderPaybackPackageFeeQuantity;
                        totalValue += e.orderPaybackPackageFeeValue;
                    });
                    this.mainTable.data.push({
                        orderPaybackPackageFeeQuantity: totalQuantity,
                        orderPaybackPackageFeeValue: totalValue,
                        orderPaybackPackageFeePrice: '合计'
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
            });
        }, onExport() {
            const searchCondition = search.deepClone(this.mainTable.tableSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.mainTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.tableLoading = true;
            getOrderPaybackPackageFeeList(searchCondition).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                }
            });
        },
        approve(id, approvalStatus) {
            approvalOrderPaybackPackageFee({
                id: id,
                approvalStatus: approvalStatus
            }).then(res => {
                if (res.code === 0) {
                    this.getMyOrderPaybackPackageFeeList(true);
                }
            });
        },
        onPass(item) {
            this.approve(item.orderPaybackPackageFeeUuid, 1);
        },
        onFail(item) {
            this.approve(item.orderPaybackPackageFeeUuid, 0);
        }
    }
};
</script>

<style scoped></style>
